import React from 'react';
import { getServiceUrl } from '../../../utils/serviceUrls';

export const RatingStars = ({ rating, hasReview, activeContent, onReviewClick, item }) => {
  const preferredService = localStorage.getItem('preferredMusicService') || 'spotify';
  const serviceUrl = item ? getServiceUrl(item.album, preferredService) : null;

  return (
    <div className="flex flex-row flex-wrap w-full items-center justify-between select-none sm:gap-4">

      <div className="flex flex-row gap-4 items-center md:opacity-0 md:group-hover:opacity-100">
        {serviceUrl && (
          <a 
            className="hover:scale-110 transition duration-100 ease-in-out opacity-30 hover:opacity-100"
            href={serviceUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="group flex flex-col justify-center items-center cursor-pointer text-center pangram-sans-bold leading-4">
              <span className="material-symbols-outlined sm:text-2xl text-xl">play_circle</span>
            </div>
          </a>
        )}
      </div>

      <div className="flex flex-row items-center justify-center">
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            className={`material-symbols-outlined -mx-[2px] text-2xl sm:leading-6 leading-4 ${index < rating ? 'star-select' : 'star-stroke opacity-30'}`}
          >
            star
          </span>
        ))}
      </div>

      <div className="flex flex-row gap-4 items-center md:opacity-0 md:group-hover:opacity-100">
        {hasReview && (
          <span
            className={`material-symbols-outlined sm:text-2xl text-xl cursor-pointer ${activeContent === 'review' ? 'opacity-100' : 'opacity-30'}`}
            onClick={onReviewClick}
          >
            more_horiz
          </span>
        )}
        {!hasReview && <span className="w-6" />}
      </div>
      
    </div>
  );
};

export default RatingStars;